import { siteInfo } from "@/mocks/site";
import { buildWhatsAppLink } from "@/utils/whatsapp";
import Reveal from "./Reveal";

const highlights = ["Lazer Epilasyon", "Cilt Bakımı", "Kalıcı Makyaj", "Kaş & Kirpik", "Bölgesel Uygulamalar"];

const aboutImage =
  "https://storage.helloreaddy.io/project_files/c4f2c66c-1a08-4ed3-87f2-fa775eeabedc/b833c26a-ef8e-41ea-9dba-ca0bb2cbcf6c_compressed_profcb1000.webp";

export default function About() {
  return (
    <section id="hakkimizda" className="ivory-canvas bg-background-50 py-16 md:py-24">
      <div className="mx-auto grid w-full max-w-7xl grid-cols-1 items-center gap-12 px-5 md:px-6 lg:grid-cols-2 lg:gap-16">
        <Reveal className="order-2 lg:order-1">
          <div className="relative">
            <div
              className="absolute -inset-3 rounded-[2rem] border border-accent-400/40"
              aria-hidden="true"
            />
            <div className="relative overflow-hidden rounded-[1.5rem] border border-background-300/70 bg-primary-950 p-2">
              <img
                src={aboutImage}
                alt="Fatma Angay Güzellik Salonu’nda profesyonel cilt bakımı uygulaması"
                title="Fatma Angay Güzellik Salonu cilt bakımı uygulaması"
                className="h-auto w-full rounded-[1.2rem] object-contain"
              />
            </div>
          </div>
        </Reveal>

        <div className="order-1 flex flex-col items-start lg:order-2">
          <span className="inline-flex items-center gap-3 font-label text-[0.7rem] font-medium uppercase tracking-[0.32em] text-accent-600">
            <span className="h-px w-8 bg-accent-500/70" aria-hidden="true" />
            Hakkımızda
          </span>

          <h2 className="mt-4 font-heading text-3xl font-semibold leading-[1.14] tracking-tight text-foreground-950 md:text-[2.6rem]">
            Bakımınıza Özenle Eşlik Ediyoruz
          </h2>

          <p className="mt-5 max-w-xl font-body text-sm leading-relaxed text-foreground-700 md:text-base">
            Fatma Angay Güzellik Salonu, Demirtaş Osmangazi’de farklı bakım ihtiyaçlarına yönelik güzellik
            uygulamalarını tek çatı altında sunar. Hizmet kapsamı, kampanya detayları ve randevu seçenekleri
            hakkında WhatsApp üzerinden hızlıca bilgi alabilirsiniz.
          </p>

          <div className="mt-7 flex flex-wrap gap-2">
            {highlights.map((item) => (
              <span
                key={item}
                className="rounded-full border border-accent-300/70 bg-accent-50 px-4 py-2 font-label text-[0.7rem] font-medium tracking-wide text-accent-800 md:text-xs"
              >
                {item}
              </span>
            ))}
          </div>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href={buildWhatsAppLink(siteInfo.defaultMessage)}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-6 py-3.5 font-label text-xs font-semibold uppercase tracking-[0.14em] text-background-50 transition-colors hover:bg-primary-700"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-whatsapp-line text-base" aria-hidden="true" />
              </span>
              WhatsApp’tan Yazın
            </a>
            <a
              href="#iletisim"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-primary-300 px-6 py-3.5 font-label text-xs font-semibold uppercase tracking-[0.14em] text-primary-700 transition-colors hover:border-primary-600"
            >
              İletişim Bilgileri
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}